export default __webpack_public_path__ + "static/media/18.8d60ed98.jpg";